import { render } from "./MimamoriTargetComponent.vue?vue&type=template&id=6c73e433"
import script from "./MimamoriTargetComponent.vue?vue&type=script&lang=js"
export * from "./MimamoriTargetComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__